export default __webpack_public_path__ + "static/media/service-img-1.98ef7307.png";